import { useContext } from "react";
import type { ViewModel } from "@lib/viewModel";
import { ViewModelContext } from "@lib/viewModel";

export const useViewModelObject = (): ViewModel => {
  const { viewModel } = useContext(ViewModelContext);
  return viewModel;
};
